export default "__VITE_ASSET__17tIEiPo__"